import React from "react";

export interface FormErrorTextProps {
  id?: string;
  message?: string;
  className?: string;
}

export function FormErrorText({ id, message, className = "" }: FormErrorTextProps) {
  if (!message) {
    return null;
  }

  return (
    <p id={id} role="alert" className={`mt-1 text-xs text-red-600 dark:text-red-400 ${className}`.trim()}>
      {message}
    </p>
  );
}

export default FormErrorText;
